module.exports = __webpack_public_path__ + "img/img_comment.1cdf4e90.svg";